import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getDataPC = (user_id) => {
  return httpClient.get(server.API_PETTYCASH_H + `/getsql/${user_id}`);
};
export const getDataPCApporver = (user_id) => {
  return httpClient.get(server.API_PETTYCASH_H + `/getsql-approver/${user_id}`);
};
export const getDataPCAccount = (user_id) => {
  return httpClient.get(server.API_PETTYCASH_H + `/getsql-account/${user_id}`);
};
export const getDataPCByID = (id) => {
  return httpClient.get(server.API_PETTYCASH_H + `/getbyid/${id}`);
};
export const getDataPCByIDSql = (id) => {
  return httpClient.get(server.API_PETTYCASH_H + `/getbyid-sql/${id}`);
};

export const createPC = (data) => {
  return httpClient.post(server.API_PETTYCASH_H + `/create`, data);
};

export const updatePCH = (id, data) => {
  return httpClient.put(server.API_PETTYCASH_H + `/update/${id}`, data);
};

export const getDataPC_Paginated = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id
) => {
  return httpClient.get(
    server.API_PETTYCASH_H + `/getsql-pagination/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
      },
    }
  );
};

export const getDataPC_PaginatedV2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  search,
  search_status,
  datefrom,
  dateto
) => {
  return httpClient.get(
    server.API_PETTYCASH_H + `/getsql-pagination-v2/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        search,
        search_status,
        datefrom,
        dateto,
      },
    }
  );
};

export const getDataPCApporver_Paginated = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id
) => {
  return httpClient.get(
    server.API_PETTYCASH_H + `/getsql-approver-pagination/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
      },
    }
  );
};


export const getDataPCApporver_PaginatedV2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  search,
  search_status,
  datefrom,
  dateto
) => {
  return httpClient.get(
    server.API_PETTYCASH_H + `/getsql-approver-pagination-v2/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        search,
        search_status,
        datefrom,
        dateto,
      },
    }
  );
};
